import styled from 'styled-components'

export const FailedLeagueVendorUpdateBlockStyle = styled.div`
  border: 1px solid ${props => props.theme.main.colors.borderColor};
  & + & {
    border-top: none;
  }
  padding: 30px 15px;
`
